import { atom } from "jotai";

export const selectedLanguageAtom = atom<string>("en");